// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"eeefa00c","623":"eeefa00c"}[chunkId] + ".chunk.css";
};